import { Form, Formik, FormikProps } from 'formik';
import { useTranslation } from 'react-i18next';
import FieldWrapper from './formInputs/FieldWrapper';
import DatePickerField from './formInputs/DatePickerField';
import FormikDebounce from './FormikDebounce';
import { ReactNode } from 'react';

export default function TableFilters({ customSearchPlaceholder, setFilters, extraFilterRows }: { customSearchPlaceholder?: string; setFilters?: any; extraFilterRows?: (formik: FormikProps<any>) => ReactNode; }) {
  const { t } = useTranslation();

  return (
    <Formik
      initialValues={{
        search: ''
      }}
      onSubmit={(values) => {
        setFilters(values);
      }}
    >
      {(formik) => (
        <Form>
          {/* <SearchInputField
          placeholder={customSearchPlaceholder || t('search_by_code_Name')}
          setSearchInput={(value: string) => formik.setFieldValue('search', value)}
          searchInput={formik?.values?.search}
        /> */}
          <FormikDebounce />
          <div className="filter_container">
            <FieldWrapper title={''} inputName={`search`} inputPlaceholder={customSearchPlaceholder || t('search_by_code_Name')} input noPadding />
            <DatePickerField title={''} name={`from_date`} noPadding placeHolder={`${t('from')}: DD/MM/YYYY`} clearable />
            <DatePickerField title={''} name={`to_date`} noPadding placeHolder={`${t('to')}: DD/MM/YYYY`} clearable />
          </div>
          {extraFilterRows && extraFilterRows(formik)}
        </Form>
      )}
    </Formik>
  );
}
